import { ISpApplicationInitialState, IThunkAPI } from '@/store/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { applicationApis } from '@/api/sp/application';
import { IApplicationUpdateStatusRequest } from '@/api/types';

export const initialState: ISpApplicationInitialState = {
  isLoading: false,
};

export const editApplication = createAsyncThunk<any, IApplicationUpdateStatusRequest, IThunkAPI>(
  'member/application/edit',
  async (payload, thunkAPI) => {
    try {
      const response = await applicationApis.editApplication(payload.applicationId, payload.currentStatusId);
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const deleteApplication = createAsyncThunk<any, IApplicationUpdateStatusRequest, IThunkAPI>(
  'member/application/delete',
  async (payload, thunkAPI) => {
    try {
      const response = await applicationApis.deleteApplication(payload.applicationId, payload.currentStatusId);
      const result = response.data;
      return { result, payload };
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const spApplicationSlice = createSlice({
  name: 'SpApplication',
  initialState,
  reducers: {
    resetSpApplicationSlice(state) {
      state.isLoading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(editApplication.pending, state => {
        state.isLoading = true;
      })
      .addCase(editApplication.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(editApplication.rejected, state => {
        state.isLoading = false;
      })
      .addCase(deleteApplication.pending, state => {
        state.isLoading = true;
      })
      .addCase(deleteApplication.fulfilled, state => {
        state.isLoading = false;
      })
      .addCase(deleteApplication.rejected, state => {
        state.isLoading = false;
      });
  },
});

//Actions
export const { resetSpApplicationSlice } = spApplicationSlice.actions;
export default spApplicationSlice.reducer;
